import React, { useState } from 'react';
import api from '../services/api';

function AddCentro({ userId, onBalanceUpdated }) {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!userId) {
      setError('Please enter your User ID first');
      return;
    }

    if (!amount || parseFloat(amount) <= 0) {
      setError('Please enter a valid amount greater than 0');
      return;
    }

    try {
      setLoading(true);
      const response = await api.addCentro(userId, parseFloat(amount));

      if (response.success) {
        setSuccess(`Successfully purchased ${parseFloat(amount).toLocaleString()} Centro!`);
        setAmount('');

        if (onBalanceUpdated) {
          onBalanceUpdated();
        }
      } else {
        setError('Failed to purchase Centro. Please try again.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const quickAddAmount = (value) => {
    setAmount(value.toString());
  };

  return (
    <div className="content-card">
      <h2 style={{ marginBottom: '25px', color: '#333' }}>Buy Centro</h2>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="amount">Centro Amount</label>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter Centro amount"
            step="0.01"
            disabled={loading}
          />
          <small style={{ color: '#666', fontSize: '0.85rem' }}>
            Purchase Centro digital reserves for your institutional account
          </small>
        </div>

        <div style={{ marginBottom: '25px' }}>
          <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '10px', fontWeight: '600' }}>Standard Amounts:</div>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {[1000000, 5000000, 10000000, 50000000].map((value) => (
              <button
                key={value}
                type="button"
                onClick={() => quickAddAmount(value)}
                className="btn btn-secondary"
                disabled={loading}
                style={{ flex: '0 1 auto' }}
              >
                {value.toLocaleString()}
              </button>
            ))}
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Processing Purchase...' : 'Buy Centro'}
        </button>
      </form>

      <div style={{ marginTop: '30px', padding: '20px', background: '#f9f9f9', borderRadius: '10px', border: '1px solid #e0e0e0' }}>
        <h3 style={{ fontSize: '1.1rem', marginBottom: '10px', color: '#1a365d', fontWeight: '600' }}>
          About Centro
        </h3>
        <p style={{ lineHeight: '1.8', color: '#666' }}>
          Centro is a digital reserve token that maintains a 1:1 peg with physical reserves held by the Reserve Bank of India.
          When you purchase Centro, an equivalent amount in physical assets is held in custody by the central bank.
          Centro can be used for settlement agreements between financial institutions on the distributed ledger.
        </p>
      </div>

      <div style={{ marginTop: '20px', padding: '15px', background: '#e8f4f8', borderRadius: '10px', border: '1px solid #b3d9e6' }}>
        <strong style={{ color: '#1a365d' }}>System Integration:</strong>
        <p style={{ color: '#2d5a7b', marginTop: '5px', fontSize: '0.9rem' }}>
          In production, this operation integrates with the Reserve Bank's core banking system to verify
          physical reserve holdings and authorize the creation of corresponding Centro tokens on the blockchain.
        </p>
      </div>
    </div>
  );
}

export default AddCentro;
